/**
 * @generated SignedSource<<7a11e1c1c644c64833698e434e83cb48>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type WidgetCalendarOverviewContent_widget$data = {
  readonly calendarEvents: {
    readonly __id: string;
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly createdAt: {
          readonly isoString: string;
        };
        readonly endAt: {
          readonly isoString: string;
        };
        readonly id: string;
        readonly isAllDayEvent: boolean;
        readonly startAt: {
          readonly isoString: string;
        };
        readonly " $fragmentSpreads": FragmentRefs<"WidgetCalendarOverviewEventItem_event">;
      };
    }>;
  } | null;
  readonly connectedCalendars: ReadonlyArray<{
    readonly id: string;
  }>;
  readonly id: string;
  readonly " $fragmentType": "WidgetCalendarOverviewContent_widget";
};
export type WidgetCalendarOverviewContent_widget$key = {
  readonly " $data"?: WidgetCalendarOverviewContent_widget$data;
  readonly " $fragmentSpreads": FragmentRefs<"WidgetCalendarOverviewContent_widget">;
};

const node: ReaderFragment = (function(){
var v0 = [
  "calendarEvents"
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "isoString",
    "storageKey": null
  }
];
return {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "after"
    },
    {
      "kind": "RootArgument",
      "name": "first"
    }
  ],
  "kind": "Fragment",
  "metadata": {
    "connection": [
      {
        "count": "first",
        "cursor": "after",
        "direction": "forward",
        "path": (v0/*: any*/)
      }
    ],
    "refetch": {
      "connection": {
        "forward": {
          "count": "first",
          "cursor": "after"
        },
        "backward": null,
        "path": (v0/*: any*/)
      },
      "fragmentPathInResult": [
        "node"
      ],
      "operation": require('./WidgetCalendarOverviewContentPaginatedQuery.graphql'),
      "identifierInfo": {
        "identifierField": "id",
        "identifierQueryVariableName": "id"
      }
    }
  },
  "name": "WidgetCalendarOverviewContent_widget",
  "selections": [
    {
      "alias": "connectedCalendars",
      "args": [
        {
          "kind": "Literal",
          "name": "includeExternal",
          "value": true
        }
      ],
      "concreteType": "StoreCalendar",
      "kind": "LinkedField",
      "name": "calendars",
      "plural": true,
      "selections": [
        (v1/*: any*/)
      ],
      "storageKey": "calendars(includeExternal:true)"
    },
    {
      "alias": "calendarEvents",
      "args": null,
      "concreteType": "StoreCalendarTeamCalendarEventsConnection",
      "kind": "LinkedField",
      "name": "__WidgetCalendarOverviewContent__calendarEvents_connection",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "StoreCalendarTeamCalendarEventsEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "CalendarEvent",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                (v1/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "StoreZonedDate",
                  "kind": "LinkedField",
                  "name": "startAt",
                  "plural": false,
                  "selections": (v2/*: any*/),
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "StoreZonedDate",
                  "kind": "LinkedField",
                  "name": "endAt",
                  "plural": false,
                  "selections": (v2/*: any*/),
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "StoreZonedDate",
                  "kind": "LinkedField",
                  "name": "createdAt",
                  "plural": false,
                  "selections": (v2/*: any*/),
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "isAllDayEvent",
                  "storageKey": null
                },
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "WidgetCalendarOverviewEventItem_event"
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__typename",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "cursor",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "PageInfo",
          "kind": "LinkedField",
          "name": "pageInfo",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "endCursor",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "hasNextPage",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "kind": "ClientExtension",
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "__id",
              "storageKey": null
            }
          ]
        }
      ],
      "storageKey": null
    },
    (v1/*: any*/)
  ],
  "type": "WidgetCalendarOverview",
  "abstractKey": null
};
})();

(node as any).hash = "09f0caba87e84b2b15d0adc386fc9aa6";

export default node;
